import type { OutwardReferralData } from 'chaika-frontend-types/frontend-cms';

// Внешнее направление принадлежит записи доктора, если выдано в ней (parentEntryId)
// или исполнено в ней (executionEntryId). Используется при показе направлений
// в записи и в её печатной форме, чтобы не всплывали направления из других записей.
export function isOutwardReferralOfEntry(outwardReferral: OutwardReferralData, entryId: string): boolean {
    return outwardReferral.parentEntryId === entryId || outwardReferral.executionEntryId === entryId;
}
